// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ExpenseReport } from './expense-report';
import { ExpenseReportLine } from './expense-report-line';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ExpenseReportLineAttachment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  deletedBy?: string;
  expenseReportId?: number;
  expenseReportLineId?: number;
  fileName?: string;
  name?: string;
  expenseReport!: ExpenseReport;
  expenseReportLine!: ExpenseReportLine;
}

